import { Expose } from 'class-transformer';
import { IsNotEmpty, IsOptional, IsUUID } from 'class-validator';
import { BaseDto } from './base.dto';

export class AddCategoryDto {
  @IsNotEmpty()
  name!: string;

  @IsNotEmpty()
  code!: string;

  @IsOptional()
  @IsNotEmpty()
  description!: string;

  @IsOptional()
  @IsNotEmpty()
  image!: string;

  @IsOptional()
  @IsUUID()
  parent!: string;
}

export class CategoryDto extends BaseDto {
  @Expose()
  name: string;

  @Expose()
  code: string;

  @Expose()
  image: string;
}
